import SpinnerIcon from "./SpinnerIcon";

const Waiting = () => (
  <div>
    <div className="absolute top-0 left-0 bottom-0 w-full h-full z-50 bg-sky-200/10">
      <div className="flex justify-center items-center h-full">
        <div className="p-3 bg-white rounded-lg shadow-lg shadow-gray-300">
          <SpinnerIcon />
        </div>
      </div>
    </div>
    <div className="absolute top-0 left-0 w-full h-full opacity-50 bg-white/50 z-50">
      <div className="flex justify-center items-center h-full"></div>
    </div>
  </div>
);
export default Waiting;
